/**
 * Account Routes (Public - No Auth Required)
 */
export default [
    {
        path: '/account/login',
        name: 'login',
        component: () => import('../../pages/account/LoginPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            guestOnly: true,
            title: 'Login',
        },
        props: (route) => ({
            returnUrl: route.query.ReturnUrl || route.query.returnUrl,
        }),
    },
    {
        path: '/account/register',
        name: 'register',
        component: () => import('../../pages/account/RegisterPage.vue'),
        meta: {
            layout: 'register',
            requiresAuth: false,
            guestOnly: true,
            title: 'Register',
        },
    },
    {
        path: '/account/forgot-password',
        name: 'forgotPassword',
        component: () => import('../../pages/account/ForgotPasswordPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Forgot Password',
        },
    },
    {
        path: '/account/reset-password',
        name: 'resetPassword',
        component: () => import('../../pages/account/ResetPasswordPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Reset Password',
        },
        props: (route) => ({
            code: route.query.code,
            email: route.query.email,
        }),
    },
    {
        path: '/account/confirm-email',
        name: 'confirmEmail',
        component: () => import('../../pages/account/ConfirmEmailPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Confirm Email',
        },
        props: (route) => ({
            code: route.query.code,
            userId: route.query.userId,
        }),
    },
    {
        path: '/account/externalloginconfirmation',
        name: 'externalLoginConfirmation',
        component: () => import('../../pages/account/ExternalLoginPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'External Login',
        },
    },
    {
        path: '/account/lockout',
        name: 'lockout',
        component: () => import('../../pages/account/LockoutPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Account Locked',
        },
    },
    {
        path: '/account/loggedout',
        name: 'loggedOut',
        component: () => import('../../pages/account/LoggedOutPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Logged Out',
        },
        props: (route) => ({
            postLogoutRedirectUri: route.query.postLogoutRedirectUri,
        }),
    },
    {
        path: '/account/loginwith2fa',
        name: 'loginWith2fa',
        component: () => import('../../pages/account/LoginWith2faPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Two-Factor Authentication',
        },
        props: (route) => ({
            returnUrl: route.query.ReturnUrl,
            rememberMe: route.query.RememberMe,
        }),
    },
    {
        path: '/account/loginwithrecoverycode',
        name: 'loginWithRecoveryCode',
        component: () => import('../../pages/account/LoginWithRecoveryCodePage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Recovery Code',
        },
    },
];
